import { render, staticRenderFns } from "./RetailerInsights.vue?vue&type=template&id=1cf61286&scoped=true&"
import script from "./RetailerInsights.vue?vue&type=script&lang=js&"
export * from "./RetailerInsights.vue?vue&type=script&lang=js&"
import style0 from "./RetailerInsights.vue?vue&type=style&index=0&id=1cf61286&lang=scss&scoped=true&"
import style1 from "./RetailerInsights.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf61286",
  null
  
)

export default component.exports